// extracted by mini-css-extract-plugin
module.exports = {"root":"landing_root__eqZlY"};